<template>
  <div>
    <div class="searchcontent headersearch">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item>
          <el-input size="small" v-model.trim="searchForm.keywords" placeholder="请输入申请人姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input size="small" v-model.trim="certificateNo" placeholder="请输入申请人证件号" onkeyup="this.value=this.value.replace(/[^\X0-9]/g, '')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select size="small" style="width:250px" v-model="searchForm.auditStatus" placeholder="请选择注销状态">
            <el-option v-for="item in searchForm.auditStatuslist" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" plain type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="searchtable">
      <el-table ref="table" :data="userlist" border stripe v-loading="showDataLoading" :header-row-style="{height:'30px'}" :header-cell-style="{padding:'5px'}" :row-style="{height:'30px'}" :cell-style="{padding:'5px'}" :height="tableHeight">
        <el-table-column prop="" label="编号" width="60">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="用户名称" width="120">
        </el-table-column>
        <el-table-column label="性别" width="60">
          <template slot-scope="scope">
            <span v-if="scope.row.userSex == 1">男</span>
            <span v-if="scope.row.userSex == 2">女</span>
          </template>
        </el-table-column>
        <el-table-column prop="birthdayTime" label="出生日期" width="150">
        </el-table-column>
        <el-table-column prop="idcardNumber" label="身份证号" width="165">
        </el-table-column>
        <el-table-column prop="contactTel" label="手机号" width="130">
        </el-table-column>
        <el-table-column prop="isLogout" label="是否注销" width="85">
          <!-- 1初婚；2再婚；3离婚；4丧偶 -->
          <template slot-scope="scope">
            <span v-if="scope.row.isLogout == 1">已注销</span>
            <span v-if="scope.row.isLogout == 0">未注销</span>
          </template>
        </el-table-column>
        <el-table-column prop="logoutReason" label="注销原因" width="120">
          <template slot-scope="scope" v-if="scope.row.logoutReason!=''">
            <span @click="getDetail(scope.row)">
              <el-link type="primary">详情</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="logoutTime" label="注销日期" width="165">
        </el-table-column>
        <el-table-column prop="addTime" label="添加日期" width="165">
        </el-table-column>
        <el-table-column label="操作" min-width="160">
          <template slot-scope="scope">
            <el-popconfirm title="您确定要启用么？" v-if="scope.row.isLogout == 1 && permission.isHaveedituserlogout==true&&adminRegionLevel<=1" iconColor="red" @confirm="closeAdminStatus(1,scope.row,scope.$index)">
              <el-button style="margin-left:5px;margin-right:5px" slot="reference" type="text" size="mini" class="tablecolumn" :disabled='scope.row.adminID==1'>启用</el-button>
            </el-popconfirm>
            <!-- v-if="scope.row.isClose == 0 && permission.isHaveDistriutionPermission==true" -->
            <el-popconfirm title="您确定要注销么？" iconColor="red" v-if="scope.row.isLogout == 0 && permission.isHaveedituserlogout==true&&adminRegionLevel<=1" @confirm="closeAdminStatus(2,scope.row,scope.$index)">
              <el-button style="margin-left:5px;margin-right:5px" slot="reference" type="text" size="mini" class="tablecolumn" :disabled='scope.row.adminID==1'>注销</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageblock">
        <el-pagination @size-change="handledatailSizeChange" @current-change="handledatailCurrentChange" :current-page="page" :page-sizes="[10, 30, 50, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="datailtotalCount">
        </el-pagination>
      </div>
    </div>
    <!-- 注销原因 -->
    <el-dialog title="注销原因" :visible.sync="diaparticularsVisible" :show-close="true" custom-class="dialog_wrap" style="margin-top:0px;left: 0px;z-index: 2154;" class="logindialog" width="600px">
      <div>
        {{particulars}}
      </div>
    </el-dialog>
    <!-- 注销 -->
    <el-dialog title="注销" :visible.sync="dialogFormVisible" :show-close="true" custom-class="dialog_wrap" @close="clearlogoutStatueForm('logoutStatueForm')" style="margin-top:0px;left: 0px;z-index: 2154;" class="logindialog" width="600px">
      <el-form ref="logoutStatueForm" label-width="130px" :model="logoutStatueForm">
        <el-form-item label="注销原因：" prop="people_logout_reason_id">
          <el-select size="medium" v-model="logoutStatueForm.people_logout_reason_id" placeholder="请选择终止原因">
            <el-option v-for="item in logoutStatueForm.peoplelogoutreasonList" :key="item.systemCodeID" :label="item.systemCodeName" :value="item.systemCodeID">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" :loading="loading" :disabled="disabled" @click="onSubmit">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { userlistModel } from "@/request/filemanage.js";
import router from "@/router.js";
import { sysframe } from '@/tools/sysframe.js'
import $ from 'jquery'
import store from '@/store'

import { publicFun } from '@/tools/time.js'
import { baseconfig } from '@/config.js'
import { permissionTool } from "@/tools/permissiontool.js";
import { systemcodeModule } from "@/request/systemmange.js";
export default {
  data() {
    return {
      disabled: false,
      loading: false,
      userindex: 1,
      userID: 0,
      // 详情
      particulars: '',
      diaparticularsVisible: false,
      dialogFormVisible: false,
      logoutStatueForm: {
        people_logout_reason_id: '',
        peoplelogoutreasonList: [],
      },

      mark: 2,
      keyindex: 0,
      applyRecordID: 0,
      tableHeight: 400,
      villageList: [],
      countryList: [],
      villageList1: [],
      countryList1: [],
      show: false,
      villshow: false,
      buttonShow: false,
      type: "info",
      p_region_id: '',
      region_level: '',

      lsp: [],
      permission: {
        isHaveedituserlogout: false,
      },
      //进来加载数据是否展示loading圈
      showDataLoading: true,

      //搜索
      page: 1,
      pagesize: 10,
      datailtotalCount: 0,
      userlist: [],
      // 搜索
      searchForm: {
        keywords: '',
        auditStatus: '',

        auditStatuslist: [
          {
            value: -1,
            label: '全部'
          },
          {
            value: 1,
            label: '已注销'
          },
          {
            value: 0,
            label: '未注销'
          },
        ],
      },
      dialogdetailVisible: false,
      dialogdataFormVisible: false,
      adminRegionLevel: 0,
      certificateNo: ''
    };
  },
  created: async function () {
    await this.getapplyaudit1userlist(1, this.pagesize, '', -1, -1, this.certificateNo)
    this.tableHeight = ($(".tab-content").height() - 30 - $(".searchcontent").outerHeight(true) - $(".pageblock").outerHeight(true)) + 'px'
    this.getSystemcodeinfogetlist(8)
    console.log(this.show, this.villshow)
    this.permission.isHaveedituserlogout = permissionTool.isHavePermission(
      "edituserlogout",
      this.lsp
    );
    this.adminRegionLevel = store.getters.adminRegionLevel



  },
  mounted: function () { },
  deactivated: function () {
    this.dialogdataFormVisible = false;
    this.dialogdetailVisible = false;
    this.diaparticularsVisible = false;
    this.dialogFormVisible = false;
  },
  methods: {
    initLeft() {
      return sysframe.getSideBarLeft()
    },

    // 注销原因
    // 不通过原因
    getDetail(row) {
      this.particulars = row.logoutReason
      this.diaparticularsVisible = true
    },
    //获取搜索框的 下拉框
    async getSystemcodeinfogetlist(mark) {
      await systemcodeModule
        .systemcodeinfogetlist(mark)
        .then((response) => {
          console.log(1111222, response)
          switch (response.data.code) {
            case 100: {
              this.logoutStatueForm.peoplelogoutreasonList = response.data.result
            }
              break;
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    clearlogoutStatueForm(logoutStatueForm) {
      this.$refs[logoutStatueForm].resetFields();
      // this.$forceUpdate()
    },


    //列表
    async getapplyaudit1userlist(page, page_size, key_words, logout_status, auth_status, id_number) {
      if (logout_status == '') {
        logout_status = -1
      }
      this.userlist = [];
      this.showDataLoading = true;
      await userlistModel.userlist(page, page_size, key_words, logout_status, auth_status, id_number).then((response) => {
        this.showDataLoading = false;
        if (response.data.lsp !== null) {
          this.lsp = response.data.lsp
        }
        switch (response.data.code) {
          case 100:
            this.userlist = response.data.result;
            this.userlist.forEach(e => {
              e.birthdayTime = publicFun.timestampToTime(e.birthdayTime).substring(0, 10)
              e.logoutTime = publicFun.timestampToTime(e.logoutTime)
              e.addTime = publicFun.timestampToTime(e.addTime)

            })
            this.datailtotalCount = response.data.recordcount;

            break;
          case 101:
            this.userlist = []
            break;
          case 100002:
            this.$message.error(baseconfig.no_permission_message);
            break;
          case 102:
            this.$message.error(response.data.message);
            break;
          default:
            this.$message.error(response.data.message);
            break;
        }
      })
        .catch((error) => { });
    },

    //更改每页显示条数
    async handledatailSizeChange(val) {
      this.pagesize = val;
      this.page = 1;
      this.getapplyaudit1userlist(this.page, this.pagesize, this.searchForm.keywords, this.searchForm.auditStatus, -1, this.certificateNo)
    },
    //设置当前页
    async handledatailCurrentChange(val) {
      this.page = val;
      this.getapplyaudit1userlist(this.page, this.pagesize, this.searchForm.keywords, this.searchForm.auditStatus, -1, this.certificateNo)
    },
    // 查询
    async onSearch() {
      this.datailtotalCount = 0;
      this.page = 1;
      this.getapplyaudit1userlist(this.page, this.pagesize, this.searchForm.keywords, this.searchForm.auditStatus, -1, this.certificateNo)
    },
    async closeAdminStatus(index, row, k) {
      if (index == 1) {
        this.userindex = index
        this.edituserlogout(row.userID, 0)
      } else {
        this.userindex = index
        this.dialogFormVisible = true
        this.userID = row.userID
      }

    },
    // 注销
    onSubmit() {
      this.edituserlogout(this.userID, this.logoutStatueForm.people_logout_reason_id)
    },
    async edituserlogout(user_id, logout_reason_id) {
      await userlistModel.edituserlogout(user_id, logout_reason_id).then(response => {
        switch (response.data.code) {
          case 100:
            if (this.userindex == 1) {
              const h = this.$createElement;
              this.$notify({
                title: "成功",
                message: h("span", "启用成功"),
                type: "success",
              })
            } else {
              this.dialogFormVisible = false
              const h = this.$createElement;
              this.$notify({
                title: "成功",
                message: h("span", "注销成功"),
                type: "success",
              })
            }

            this.getapplyaudit1userlist(this.page, this.pagesize, this.searchForm.keywords, this.searchForm.auditStatus, -1, this.certificateNo)
            break;
          case 100002:
            this.$message.error(baseconfig.no_permission_message);
            break;
          case 102:
            this.$message.error(response.data.message);
            break;
          default:
            this.$message.error(response.data.message);
            break;
        }
      }).catch(function (error) { })
    }

  },
};
</script>
<style scoped>
.elpopconfirm >>> .el-button {
  padding: 9px 20px;
  margin-top: 2px;
}
</style>

